import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class GlobalService {
	public darkModeOn = new BehaviorSubject<boolean>(localStorage.getItem('darkMode') == 'true');
	public isLoadingRoute = new BehaviorSubject<boolean>(false);

	public isProfileMenuOpen = signal(null);
}
